import React from "react";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Link from "@material-ui/core/Link";

const styles = theme => ({
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "5px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
});

const vsc = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h5" color="primary" component="h2">
        Version Control
      </Typography>
      <Typography paragraph className={classes.para}>
        Version control is a system that records changes to a file or set of
        files over time so that we can get specific versions later. There are
        two types of VCS, Centralized Version Control System (CVCS) and
        Distributed Version Control System (DVCS).
        <br />
        Centralized VCS works on a single repository to which users can directly
        access a central server. Every operation is performed directly on the
        repository.
        <br />
        In Distributed VCS, every contributor has a local copy or “clone” of the
        main repository which contains all the files and metadata present in the
        main repository. They can commit and update their local repository
        without any interference. Local repositories can be updated with new
        data from the central server by an operation called “pull” and affect
        changes to the main repository by an operation called “push” from local
        repository.
        <br />
        Git/Gitlab is a distributed version-control system.
      </Typography>
      <Typography variant="h5" color="primary" component="h2">
        Added SSH key to Gitlab
      </Typography>
      <Typography paragraph className={classes.para}>
        I followed the instructions in the fabcloud page '
        <Link color="secondary"
          target="_blank"
          href={
            "https://gitlab.fabcloud.org/help/ssh/README#generating-a-new-ssh-key-pair"
          }
        >
          generating ssh key pair
        </Link>
        ' to generate the key and test the connection.
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./gitlab_ssh_setup_2.png"
            alt="Schematic"
          />
        </div>
        <br />
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./gitlab_ssh_setup_3.png"
            alt="Schematic"
          />
        </div>
        <br />
        Next, I created a test-git repository in my gitlab account to practice
        git. I successfully created a README.md file and pushed it to the
        repository.
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./test-git.png" alt="Schematic" />
        </div>
        <br />
      </Typography>
      <Typography variant="h5" color="primary" component="h2">
        Get Personal Access Token for HTTPS client - SourceTree
      </Typography>
      <Typography paragraph className={classes.para}>
        I setup SourceTree to use Git GUI. I created{" "}
        <Link color="secondary"
          target="_blank"
          rel="noopener noreferrer"
          href={"https://gitlab.fabcloud.org/profile/personal_access_tokens"}
        >
          personal access tokens
        </Link>{" "}
        in gitlab then used it to authenticate Sourcetree. Its interface is very
        intuitive and particularly helpful when choosing partial changes for
        each commit.
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./sourcetree.png" alt="Schematic" />
        </div>
      </Typography>
      <Typography variant="h5" color="primary" component="h2">
        Git-it Tutorial
      </Typography>
      <Typography paragraph className={classes.para}>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./vcs/git_c_list.png"
            alt="Schematic"
          />
        </div>
      </Typography>
      <Typography variant="subtitle1" component="h2">
        1. Install and configure Git
      </Typography>
      <Typography paragraph className={classes.para}>
        I installed git from{" "}
        <Link color="secondary"
          href={"http://git-scm.com/downloads"}
          blank="_blank"
          rel="noopener noreferrer"
        >
          git-scm.com/downloads
        </Link>{" "}
        for my windows pc.
        <br />
        Next, I installed git-it using npm with this command
        <br />{" "}
        <Link color="secondary"
          href={"https://www.npmjs.com/package/git-it"}
          blank="_blank"
          rel="noopener noreferrer"
        >
          <code className="w3-codespan">npm i -g git-it</code>
        </Link>
        <br />
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./vcs/Screenshot_1.png"
            alt="Schematic"
          />
        </div>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./vcs/Screenshot_2.png"
            alt="Schematic"
          />
        </div>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./vcs/Screenshot_3.png"
            alt="Schematic"
          />
        </div>
      </Typography>
      <Typography variant="subtitle1" component="h2">
        2. Create a local repository
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./vcs/Screenshot_4.png"
          alt="Schematic"
        />
      </div>
      <Typography variant="subtitle1" component="h2">
        3. Check status, add and commit changes
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./vcs/Screenshot_5.png"
          alt="Schematic"
        />
      </div>
      <Typography variant="subtitle1" component="h2">
        4. Get a GitHub account
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./vcs/Screenshot_6.png"
          alt="Schematic"
        />
      </div>
      <Typography variant="subtitle1" component="h2">
        5. Connect local repositories to remote ones on GitHub.com
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./vcs/Screenshot_7.png"
          alt="Schematic"
        />
      </div>
      <Typography variant="subtitle1" component="h2">
        6. Fork and clone an open source repository
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./vcs/Screenshot_8.png"
          alt="Schematic"
        />
      </div>
      <Typography variant="subtitle1" component="h2">
        7. Create a branch for features/changes
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./vcs/Screenshot_9.png"
          alt="Schematic"
        />
      </div>
      <Typography variant="subtitle1" component="h2">
        8. Add and sync with a collaborator (Hi, @reporobot!)
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./vcs/Screenshot_10.png"
          alt="Schematic"
        />
      </div>
      <Typography variant="subtitle1" component="h2">
        9. Push and pull to sync changes to GitHub.com
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./vcs/Screenshot_11.png"
          alt="Schematic"
        />
      </div>
      <Typography variant="subtitle1" component="h2">
        10. Create a pull request
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./vcs/Screenshot_12.png"
          alt="Schematic"
        />
      </div>
      <Typography variant="subtitle1" component="h2">
        11. Merge and delete branches
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./vcs/Screenshot_13.png"
          alt="Schematic"
        />
      </div>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./vcs/Screenshot_14.png"
          alt="Schematic"
        />
      </div>
      At the end of the tutorial I could find my github username "majnun1337"
      listed at{" "}
      <Link color="secondary"
        href={"http://jlord.github.io/patchwork"}
        target="_blank"
        rel="noopener noreferrer"
      >
        jlord/patchwork gh-page
      </Link>{" "}
    </div>
  );
};

export default withStyles(styles)(vsc);
